import React, { useState, FocusEvent } from "react";
import { Field } from "react-final-form";

interface Option {
    label: string;
    value: string;
}

interface FloatingFieldProps {
    name: string;
    label: string;
    type: "text" | "number" | "select";
    handleChange: (field: string, value: string) => void;
    validate?: (value: any, allValues?: object) => any;
    options?: Option[];
    disabled?: boolean;
}

const FloatingField: React.FC<FloatingFieldProps> = ({
    name,
    label,
    type,
    handleChange,
    validate,
    disabled,
    options = [],
}) => {
    const [focused, setFocused] = useState(false);

    const handleFocus = () => setFocused(true);
    const handleBlur = (e: FocusEvent<any>) => setFocused(false);

    return (
        <div
            style={{
                padding: "20px",
                borderBottom:
                    name !== "people" ? "1px solid lightgrey" : undefined,
                position: "relative",
            }}
        >
            <Field name={name} validate={validate}>
                {({ input, meta }) => {
                    const hasValue =
                        input.value !== "" && input.value !== undefined;

                    return (
                        <div style={{ position: "relative" }}>
                            <label
                                htmlFor={name}
                                style={{
                                    position: "absolute",
                                    left: "0",
                                    top: focused || hasValue ? "-10px" : "10px",
                                    fontSize:
                                        focused || hasValue
                                            ? "12px"
                                            : "clamp(14px, 2vw, 18px)",
                                    fontFamily: "Lato",
                                    color:
                                        focused || hasValue ? "#333" : "#999",
                                    transition: "0.2s ease",
                                    pointerEvents: "none",
                                }}
                            >
                                {label}
                            </label>

                            {type === "select" ? (
                                <select
                                    disabled={disabled}
                                    {...input}
                                    id={name}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        input.onChange(e);
                                        handleChange(name, e.target.value);
                                    }}
                                    style={{
                                        backgroundColor: "#FAFAFA",
                                        width: "100%",
                                        border: "none",
                                        fontFamily: "Lato",
                                        outline: "none",
                                        fontSize: "clamp(14px, 2vw, 18px)",
                                        paddingTop: "18px",
                                    }}
                                >
                                    <option value="" disabled hidden />
                                    {options.map((opt) => (
                                        <option
                                            key={opt.value}
                                            value={opt.value}
                                        >
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    {...input}
                                    id={name}
                                    type={type}
                                    min={type === "number" ? 0 : undefined}
                                    onWheel={
                                        type === "number"
                                            ? (e) => e.currentTarget.blur()
                                            : undefined
                                    }
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        input.onChange(e);
                                        handleChange(name, e.target.value);
                                    }}
                                    style={{
                                        backgroundColor: "#FAFAFA",
                                        width: "100%",
                                        border: "none",
                                        fontFamily: "Lato",
                                        outline: "none",
                                        fontSize: "clamp(14px, 2vw, 18px)",
                                        paddingTop: "18px",
                                    }}
                                />
                            )}

                            {meta.touched && meta.error && (
                                <span
                                    style={{ color: "red", fontSize: "12px" }}
                                >
                                    {meta.error}
                                </span>
                            )}
                        </div>
                    );
                }}
            </Field>
        </div>
    );
};

export default FloatingField;
